import "./customer-profile.css";
import { Helmet } from "react-helmet";
import { useState, useEffect, useRef , useContext} from "react";
import { sendRequest } from "../../utilities/useAxios";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/prime.css";
import AuthenticationContext from "Authentication/AuthenticationContext";
import axios from "axios";

export default function CustomerProfile() {
  const {userInfo} = useContext(AuthenticationContext);
  const [allItems, setAllItems] = useState([]);
  const [allOptions, setAllOptions] = useState([]);
  const [updater, setUpdater] = useState(false);
  const [profileValue, setProfileValue] = useState({
    id: 0,
    user_name: "",
    password: "",
    fname: "",
    lname: "",
    email: "",
    fathername: "",
    codemeli: "",
    selectedOption: -1,
    provinceOption: "",
    mobile: "",
    tell: "",
    profilePicture: null,
    address: "",
    birthday: "",
    year: "",
    month: "",
    day: "",
    sextype: "",
  });
  const inputRef = useRef();
  const changeHandler = (e) => {
    setProfileValue({ ...profileValue, [e.target.name]: e.target.value });
    console.log({ ...profileValue, [e.target.name]: e.target.value });
  };
  const changeHandlerImg = (e) => {
    setProfileValue({ ...profileValue, [e.target.name]: e.target.files[0] });
  };
  useEffect(() => {
         let id = userInfo.id;
        // let id = 117;
    let myFormData = new FormData();
    myFormData.append("conditions", `id/=/${id}`);

    axios
      .post("http://mvc.dade24.ir/api/Find_users", myFormData)
      .then(function ({ data }) {
        let x = new DateObject({ calendar: persian });
        if (data[0].bdyear != 0 && data[0].bdmonth != 0 && data[0].bdday != 0) {
          x = new DateObject({ calendar: persian, year: data[0].bdyear, month: data[0].bdmonth, day: data[0].bdday });
        }
        console.log(data[0].profilepic);
        setProfileValue({
          id: data[0].id,
          user_name: data[0].nikname,
          password: data[0].password,
          fname: data[0].fname,
          lname: data[0].lname,
          email: data[0].email,
          fathername: data[0].fathername,
          codemeli: data[0].codemelli,
          selectedOption: data[0].cityid,
          mobile: data[0].mobile,
          tell: data[0].tell,
          profilePicture: data[0].profilepic,
          address: data[0].address,
          birthday: x,
          year: data[0].bdyear,
          month: data[0].bdmonth,
          day: data[0].bdday,
          sextype: data[0].jender,
        });
      })
      .catch(function (error) {
        console.log(error);
      });

    let FD = new FormData();

    axios
      .post("http://mvc.dade24.ir/api/Find_cities", {
        data: FD,
      })
      .then((response) => {
        setAllOptions(response.data);
      });
  }, [updater]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("profileValue", profileValue);
    let myFormData = new FormData();
    //let id = 117;
     let id = userInfo.id;
    myFormData.append("conditions", `id/=/${id}`);
    myFormData.append(
      "keyvalues",
      `fathername,${profileValue.fathername}@@fname,${profileValue.fname}@@profilepic,
  @@lname,${profileValue.lname}@@mobile,${profileValue.mobile}@@nikname,${profileValue.user_name}@@password,${profileValue.password}@@codemelli,${profileValue.codemeli}@@cityid,${profileValue.selectedOption}@@tell,${profileValue.tell}@@email,${profileValue.email}@@jender,${profileValue.sextype}@@address,${profileValue.address}@@bdyear,${profileValue.year}@@bdmonth,${profileValue.month}@@bdday,${profileValue.day}`
    );
    myFormData.append("profilepic", profileValue.profilePicture);
    console.log("profileValue.address", profileValue.address);
    axios.post("http://mvc.dade24.ir/api/Update_users", myFormData).then(() => setUpdater(!updater));
  };
  return (
    <>
      <div className="container-fluid customer-profile-container sendEditedProfile customer-profile">
        <div>
          <div className="row flex-wrap justify-content-center">
            {/*sidebar*/}
            <div className="d-flex flex-nowrap">
              <div className="col-lg-12">
                <div className="main bg-light round">
                  <form onSubmit={handleSubmit} className=" d-flex flex-wrap mt-3 needs-validation" id="edit-customer-profile">
                    <div className="col-md-6 col-12">
                      <div className="row input-margin size3">
                        <label htmlFor="user_name" className="col-sm-3 col-form-label size2 d-flex">
                          <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "rgb(211, 6, 6)", marginLeft: 7 }} width={11} height={11} fill="currentColor" className="bi bi-star-fill" viewBox="0 0 16 16">
                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                          </svg>
                          <div className="w-100">نام نمایشی : </div>
                        </label>
                        <div className="col-sm-9">
                          <input onChange={changeHandler} value={profileValue.user_name} type="text" className="form-control input-color" id="user_name" name="user_name" required />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-12">
                      <div className="row input-margin size3">
                        <label htmlFor="name" className="col-sm-3 col-form-label size2 d-flex  ">
                          <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "rgb(211, 6, 6)", marginLeft: 7 }} width={11} height={11} fill="currentColor" className="bi bi-star-fill" viewBox="0 0 16 16">
                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                          </svg>
                          پسوورد :
                        </label>
                        <div className="col-sm-9">
                          <input type="text" className="form-control input-color" id="name" required onChange={changeHandler} value={profileValue.password} name="password" />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-12">
                      <div className="row input-margin size3">
                        <label htmlFor="fname" className="col-sm-3 col-form-label size2 d-flex ">
                          <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "rgb(211, 6, 6)", marginLeft: 7 }} width={11} height={11} fill="currentColor" className="bi bi-star-fill" viewBox="0 0 16 16">
                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                          </svg>
                          نام :
                        </label>
                        <div className="col-sm-9">
                          <input type="text" className="form-control input-color" id="fname" required onChange={changeHandler} value={profileValue.fname} name="fname" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="row input-margin">
                        <label htmlFor="last-name" className="col-sm-3 col-form-label size2 d-flex">
                          <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "rgb(211, 6, 6)", marginLeft: 7 }} width={11} height={11} fill="currentColor" className="bi bi-star-fill" viewBox="0 0 16 16">
                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                          </svg>
                          نام خانوادگی :
                        </label>
                        <div className="col-sm-9">
                          <input type="text" className="form-control input-color" id="last-name" required name="lname" value={profileValue.lname} onChange={changeHandler} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-12">
                      <div className="row input-margin">
                        <label htmlFor="email" className="col-sm-3 col-form-label size2 d-flex">
                          <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "rgb(211, 6, 6)", marginLeft: 7 }} width={11} height={11} fill="currentColor" className="bi bi-star-fill" viewBox="0 0 16 16">
                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                          </svg>
                          ایمیل :
                        </label>
                        <div className="col-sm-9">
                          <input type="text" onChange={changeHandler} value={profileValue.email} className="form-control input-color" id="email" required name="email" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="row input-margin">
                        <label htmlFor="fathername" className="col-sm-3 col-form-label size2 d-flex">
                          نام پدر :
                        </label>
                        <div className="col-sm-9">
                          <input type="text" onChange={changeHandler} value={profileValue.fathername} className="form-control input-color" id="fathername"  name="fathername" />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-12">
                      <div className="row input-margin">
                        <label htmlFor="id-code" className="col-sm-3 col-form-label size2 d-flex">
                          <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "rgb(211, 6, 6)", marginLeft: 7 }} width={11} height={11} fill="currentColor" className="bi bi-star-fill" viewBox="0 0 16 16">
                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                          </svg>
                          کدملی:
                        </label>
                        <div className="col-sm-9">
                          <input type="number" value={profileValue.codemeli} onChange={changeHandler} className="form-control input-color" id="id-code" required name="codemeli" />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-12">
                      <div className="row input-margin">
                        <label htmlFor="cityid" className="col-sm-3 col-form-label size2">
                          شهر :
                        </label>
                        <div className="col-sm-9">
                          <select onChange={changeHandler} value={profileValue.selectedOption} className="form-select input-color" id="cityid" name="selectedOption">
                            <option
                selected
                hidden
                disabled
                value="-1"
              >
                انتخاب کنید
              </option>
                            {allOptions?.map((value, index) => (
                              <option key={index} value={value.id}>
                                {value.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-12">
                      <div className="row input-margin">
                        <label htmlFor="mobile" className="col-sm-3 col-form-label size2 ">
                          موبایل:{" "}
                        </label>
                        <div className="col-sm-9">
                          <input type="number" onChange={changeHandler} value={profileValue.mobile} className="form-control input-color " id="mobile" name="mobile" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="row input-margin">
                        <label htmlFor="tell" className="col-sm-3 col-form-label size2">
                          تلفن:{" "}
                        </label>
                        <div className="col-sm-9">
                          <input type="number" value={profileValue.tell} onChange={changeHandler} className="form-control input-color " id="tell" name="tell" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="row input-margin">
                        <label htmlFor="profile-pic" className="col-sm-3 col-form-label size2 ">
                          عکس پروفایل
                        </label>
                        <div className="col-sm-9">
                          <input type="file" ref={inputRef} onChange={changeHandlerImg} className="form-control input-color " id="profile-pic" name="profilePicture" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="row input-margin">
                        <label htmlFor="birth-date" className="col-sm-3 col-form-label size2">
                          تاریخ تولد:
                        </label>
                        <div className="col-sm-9">
                          <DatePicker
                            style={{ height: "38px", backgroundColor: "#bae4de" }}
                            inputClass="w-100 border-0 form-control"
                            containerClassName="w-100"
                            className="rmdp-prime w-100"
                            showOtherDays
                            calendar={persian}
                            locale={persian_fa}
                            calendarPosition="bottom-right"
                            id="birth-date"
                            name="birthdayts"
                            onChange={(value) => {
                              // let f= new DateObject(value);
                              // console.log(f);
                              setProfileValue({ ...profileValue, birthday: value, year: value.year, month: value.month, day: value.day });

                              // setProfileValue({...profileValue, year:x[0], month:x[1],day:x[2]});
                              // console.log({...profileValue, year:x[0], month:x[1],day:x[2]});
                            }}
                            value={profileValue.birthday}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="row input-margin">
                        <label htmlFor="birth-date" className="col-sm-3 col-form-label size2">
                          آدرس
                        </label>
                        <div className="col-sm-9">
                          <input onChange={changeHandler} value={profileValue.address} type="text" className="form-control input-color" id="address" name="address" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="row input-margin">
                        <label htmlFor="sextype" className="col-sm-3 col-form-label size2">
                          جنسیت:{" "}
                        </label>
                        <div className="col-sm-9">
                          <select onChange={changeHandler} value={profileValue.sextype} className="form-select  input-color size3" name="sextype" id="sextype">
                          <option
                selected
                hidden
                disabled
                className="size2"
              ></option>
                            <option value={0} className="size2">
                              مرد
                            </option>
                            <option value={1} className="size2">
                              زن
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="mx-auto">
                      <button
                        className="btn m-4 text-white submit-btn px-4"
                        type="submit"
                        // onClick={() => {
                        //   sendEditedProfile();
                        // }}
                      >
                        ذخیره اطلاعات
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* {UserInformation && (
              )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
// const onSubmit = (values) => {
//   axios
//     .post("http://localhost:3000/users", values)
//     .then((res) => console.log(res.data))
//     .catch((err) => console.log(err));
// };

// useEffect(() => {
//   axios
//     .get("http://localhost:3000/users/1")
//     .then((res) => setFormValues(res.data))
//     .catch((err) => console.log(err));
// }, []);

// const [UserInformation, setUserInformation] = useState(true);

// useEffect(() => {
//   sendRequest("getfulluser").then(({ data }) => {
//     setUserInformation((prev) => {
//       return data.user;
//     });
//   });
// }, []);

// function sendEditedProfile() {
//   let formData = new FormData(document.getElementById("edit-customer-profile"));

//   sendRequest("edituser", formData).then(({ data }) => {
//     if (data.state == 1) {
//       Swal.fire("مشخصات  ویرایش شد", "", "success");
//     } else {
//       Swal.fire("مشکلی در ویرایش مشخصات پیش آمده است", "", "warning");
//     }
//   });
// }
